// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__vDBPO","letter":"Logo_letter__R6Gj1","spacer":"Logo_spacer__00STf"};